export default "/images/67ef981db834ca77d288b8b1219ce4f5.avif";